import { inject, injectable } from 'inversify';
import { SockJsAdapter, Connection } from '@dealroadshow/socket-frontend-sdk';
import evercallUrl from '@evercall/url';
import { ISocketAdapter } from './DI/interfaces';
import DITypes from './DI/types';

@injectable()
export class SocketAdapter extends SockJsAdapter implements ISocketAdapter {
  constructor(
    @inject(DITypes.SocketConnection) connection: Connection,
  ) {
    super(evercallUrl.getRpcUrl({ disableProxy: true }), connection);
  }
}
